<template>
  <b-row>
    <b-col class="text-required">
      <p class="orange">* Dados obrigatórios</p>
      <p class="text-blue" v-if="cmeTerms">
        ** Dados solicitados nos termos da Resoluçao CME/BH N01/2019
      </p>
    </b-col>
  </b-row>
</template>

<script>
export default {
  name: "RequiredFieldsMessage",
  props: {
    cmeTerms: {
      type: Boolean,
      default: true,
    },
  },
};
</script>
